import React, { useEffect, useRef } from 'react';
export function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = heroRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <>
      {/* Sticky Nav */}
      <nav className="sticky-nav" data-id="element-88">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-89">
          <div className="font-playfair text-lg font-bold" style={{
          color: 'var(--color-dark)'
        }} data-id="element-90">
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-91">
              ✦
            </span>{' '}
            Exosome Express
          </div>
          <a href="https://glylife.com/cart/52895245762903:1" target="_blank" rel="noopener noreferrer" className="btn-cta-sm font-lato font-bold text-sm px-4 py-2 rounded-full transition-all duration-300 hover:scale-105" style={{
          background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
          color: 'var(--color-dark)',
          boxShadow: '0 2px 12px rgba(212, 168, 83, 0.35)'
        }} data-id="element-92">
            Obtén el Protocolo €6.39
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <section ref={heroRef} className="relative min-h-screen pt-16 overflow-hidden" style={{
      background: 'linear-gradient(135deg, #FDF8F0 0%, #F5EDD8 45%, #EDD9B0 100%)'
    }} data-id="element-93">
        {/* Decorative background circles */}
        <div className="absolute top-20 right-0 w-96 h-96 rounded-full opacity-20 pointer-events-none" style={{
        background: 'radial-gradient(circle, #D4A853 0%, transparent 70%)'
      }} data-id="element-94" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-15 pointer-events-none" style={{
        background: 'radial-gradient(circle, #C4714A 0%, transparent 70%)'
      }} data-id="element-95" />

        <div className="max-w-6xl mx-auto px-4 py-12 lg:py-20" data-id="element-96">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-97">
            {/* Left: Content */}
            <div className="order-2 lg:order-1" data-id="element-98">
              {/* Badge */}
              <div className="reveal inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-lato font-bold mb-6" style={{
              background: 'rgba(212, 168, 83, 0.15)',
              border: '1px solid rgba(212, 168, 83, 0.4)',
              color: 'var(--color-gold-dark, #B8903A)'
            }} data-id="element-99">
                <span data-id="element-100">✦</span>
                <span data-id="element-101">Protocolo Clínico Adaptado · Mercadona</span>
              </div>

              {/* Main Headline */}
              <h1 className="reveal reveal-delay-1 font-playfair text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-3" style={{
              color: 'var(--color-dark)'
            }} data-id="element-102">
                Rutina Antiarrugas
                <br data-id="element-103" />
                <span style={{
                color: 'var(--color-terracotta)'
              }} data-id="element-104">
                  40+
                </span>{' '}
                en{' '}
                <span style={{
                background: 'linear-gradient(135deg, #D4A853, #C4714A)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-105">
                  7 Días
                </span>
              </h1>

              {/* Subheadline */}
              <p className="reveal reveal-delay-2 font-playfair text-xl md:text-2xl font-semibold italic mb-4" style={{
              color: 'var(--color-gold)'
            }} data-id="element-106">
                Exosome Express de Mercadona
              </p>

              {/* Body */}
              <p className="reveal reveal-delay-2 font-lato text-lg mb-5 leading-relaxed" style={{
              color: 'var(--color-dark-mid, #4A2E1E)'
            }} data-id="element-107">
                Piel firme y luminosa en una semana{' '}
                <strong data-id="element-108">SIN cirugías ni serums costosos</strong>
              </p>

              {/* Emotional hook */}
              <div className="reveal reveal-delay-3 rounded-2xl p-5 mb-7 border-l-4" style={{
              background: 'rgba(44, 24, 16, 0.05)',
              borderLeftColor: 'var(--color-gold)'
            }} data-id="element-109">
                <p className="font-lato text-base leading-relaxed" style={{
                color: 'var(--color-dark)'
              }} data-id="element-110">
                  <span className="font-bold" data-id="element-111">Es 19:45.</span> Llegas del
                  trabajo en Madrid. Te miras al espejo. Las arrugas de
                  entrecejo que ayer eran sutiles, hoy son surcos profundos.
                  Estrés, sol mediterráneo, noches malas.{' '}
                  <em data-id="element-112">Mañana tienes videollamada clave.</em>
                </p>
              </div>

              {/* CTAs */}
              <div className="reveal reveal-delay-4 flex flex-col sm:flex-row gap-4 mb-8" data-id="element-113">
                <a href="https://glylife.com/cart/52895245762903:1" target="_blank" rel="noopener noreferrer" className="btn-gold-pulse font-lato font-black text-lg px-8 py-4 rounded-full text-center transition-all duration-300 hover:scale-105 hover:brightness-110" style={{
                background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
                color: 'var(--color-dark)',
                boxShadow: '0 4px 20px rgba(212, 168, 83, 0.5)'
              }} data-id="element-114">
                  Obtén Tu Protocolo Ahora — €6.39
                </a>
                <a href="#que-recibes" className="font-lato font-bold text-base px-6 py-4 rounded-full text-center border-2 transition-all duration-300 hover:bg-opacity-10" style={{
                borderColor: 'var(--color-gold)',
                color: 'var(--color-gold)',
                background: 'transparent'
              }} data-id="element-115">
                  Ver qué incluye ↓
                </a>
              </div>

              {/* Trust badges */}
              <div className="reveal reveal-delay-5 flex flex-wrap gap-3" data-id="element-116">
                <span className="font-lato text-sm font-bold px-3 py-2 rounded-full" style={{
                background: 'rgba(92, 107, 58, 0.12)',
                color: 'var(--color-olive)',
                border: '1px solid rgba(92, 107, 58, 0.25)'
              }} data-id="element-117">
                  ✓ Ingredientes Mercadona &lt;12€
                </span>
                <span className="font-lato text-sm font-bold px-3 py-2 rounded-full" style={{
                background: 'rgba(92, 107, 58, 0.12)',
                color: 'var(--color-olive)',
                border: '1px solid rgba(92, 107, 58, 0.25)'
              }} data-id="element-118">
                  ✓ 5-7 min AM/PM
                </span>
                <span className="font-lato text-sm font-bold px-3 py-2 rounded-full" style={{
                background: 'rgba(92, 107, 58, 0.12)',
                color: 'var(--color-olive)',
                border: '1px solid rgba(92, 107, 58, 0.25)'
              }} data-id="element-119">
                  ✓ Resultados día 4
                </span>
              </div>
            </div>

            {/* Right: Image */}
            <div className="order-1 lg:order-2 relative" data-id="element-120">
              <div className="reveal relative rounded-3xl overflow-hidden shadow-2xl" style={{
              boxShadow: '0 25px 60px rgba(44, 24, 16, 0.2), 0 0 40px rgba(212, 168, 83, 0.15)'
            }} data-id="element-121">
                <img src="https://cdn.magicpatterns.com/uploads/p4J8Q4DbJanNwnBorpgniv/ef675429-dcf1-4615-b896-60a05693e112.png" alt="Mujer en baño cálido sosteniendo tablet con Rutina Antiarrugas 40+ en 7 Días" className="w-full h-auto object-cover" style={{
                maxHeight: '600px',
                objectPosition: 'center top'
              }} data-id="element-122" />
                {/* Overlay gradient at bottom */}
                <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{
                background: 'linear-gradient(to top, rgba(245, 237, 216, 0.6), transparent)'
              }} data-id="element-123" />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 md:bottom-6 md:left-6 rounded-2xl px-5 py-3 shadow-xl" style={{
              background: 'var(--color-dark)',
              border: '1px solid rgba(212, 168, 83, 0.3)'
            }} data-id="element-124">
                <p className="font-playfair text-sm font-bold" style={{
                color: 'var(--color-gold)'
              }} data-id="element-125">
                  Resultados día 4
                </p>
                <p className="font-lato text-xs" style={{
                color: 'rgba(253, 248, 240, 0.8)'
              }} data-id="element-126">
                  Arrugas rellenadas 20-40%
                </p>
              </div>

              {/* Floating price badge */}
              <div className="absolute -top-4 -right-4 md:top-6 md:right-6 rounded-full w-20 h-20 flex flex-col items-center justify-center shadow-xl" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 20px rgba(212, 168, 83, 0.5)'
            }} data-id="element-127">
                <span className="font-lato text-xs font-bold line-through opacity-60" style={{
                color: 'var(--color-dark)'
              }} data-id="element-128">
                  €17
                </span>
                <span className="font-playfair text-lg font-black" style={{
                color: 'var(--color-dark)'
              }} data-id="element-129">
                  €6.39
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}